import {Injectable} from '@angular/core';
import * as moment from "moment-timezone";

@Injectable()
export class DateService {

  constructor() {
  }

  firstValidBusinessDay(leadTime: number): Date {
    const day = new Date();

    let businessDays = 0;
    while (businessDays !== leadTime) {
      if (![0, 6].includes(day.getDay())) {
        businessDays += 1;
      }
      day.setDate(day.getDate() + 1);
    }

    day.setMinutes(0);
    day.setSeconds(0);
    return day;
  }

  stringToNgbDate(
    dateString: string
  ): { year: number; month: number; day: number } {
    if (dateString === null) {
      return null;
    }

    let date = new Date(dateString);
    if (dateString.match(/^\d{4}-\d{2}-\d{2}$/)) {
      return this.dateToNgbDate(
        new Date(date.getTime() + date.getTimezoneOffset() * 60000)
      );
    }

    return this.dateToNgbDate(date);
  }

  dateToNgbDate(date: Date): { 'year': number, 'month': number, 'day': number } {
    if (date === null) {
      return null
    }
    return {'year': date.getFullYear(), 'month': date.getMonth() + 1, 'day': date.getDate()};
  }

  ngbDateToDate(date: { year: number, month: number, day: number }): Date {
    if (date === null) {
      return null
    }
    return new Date(date.year, date.month - 1, date.day);
  }

  ngbDateToDateWithoutTimezone(date: { year: number; month: number; day: number }): String {
    if (date === null) {
      return null;
    }
    let dateString = `${date.month}-${date.day}-${date.year}`;

    let onlyDate = moment(dateString, "MM-DD-YYYY").format("YYYY-MM-DD");
    return onlyDate + 'T08:00:00+00:00';

  }

}
